import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { PortalAppState } from "../../store/reducer";
import { Store } from "@ngrx/store";
import { ClearErrorMessage, UserService } from "common-lib";
import { MatDialog } from "@angular/material/dialog";
import { DialogComponent } from '../../components/dialog/dialog.component';
import { Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'partner-login-page',
    templateUrl: './partner-login.page.html',
    styleUrls: ['./partner-login.page.scss'],
    standalone: false
})
export class PartnerLoginPage implements OnInit,OnDestroy {

  form: UntypedFormGroup;
  error: any;

  private state: string;
  private redirectUri: string;

  errorSub: Subscription;

  constructor(
    protected store: Store<PortalAppState>,
    private userService: UserService,
    public dialog: MatDialog,
    private route: ActivatedRoute

  ) {
    this.form = new UntypedFormGroup({
      userName: new UntypedFormControl('', {
        validators: [Validators.required],
        updateOn: "submit"
      }),
      password: new UntypedFormControl('', {
        validators: [Validators.required],
        updateOn: "submit"
      })
    });
  }

  ngOnInit() {
    this.state = this.route.snapshot.queryParamMap.get('state');
    this.redirectUri = this.route.snapshot.queryParamMap.get('redirect_uri');
  }

  submitLogin(formValue: any) {
    this.userService.partnerLogin(formValue, this.redirectUri, this.state).subscribe({
      next: (response: any) => {
        console.log('Login successful, received response:', response);

        if (response && response.redirectUrl) {
          window.location.href = response.redirectUrl;
        }
      },
      error: (err) => {
        console.error('Login failed', err);
        this.showErrorDialog();
      }
    });
  }

  showErrorDialog() {
    let title = 'We are sorry!';
    let msg = 'The username or password that you entered is incorrect. Please re-enter your credentials.';
    let closeLabel = 'Close';

    const dialogRef = this.dialog.open(DialogComponent, {
      panelClass: "error-dialog",
      height: '300px',
      width: '300px',
      data: {
        header: title,
        content: msg,
        primaryBtnLabel: closeLabel,
    },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.store.dispatch(new ClearErrorMessage());
    });
  }

  ngOnDestroy(): void {
    this.errorSub.unsubscribe();
  }
}
